import { asOldPathValue } from './pmCallPagesShape';

/**
 * One Assets page-file row as the rest of the portal expects it (PORTAL-72): the same shape the old
 * path's XML parser produced from XServiceGetServiceContractUnits. A pure module, so the Playwright
 * comparison can use the very same function the browser does rather than a copy.
 *
 * Every value goes through asOldPathValue (null -> '', padding trimmed, midnight dates as the date alone,
 * digits-only text as a number - SerialNo 0067457 becomes 67457, as it always has).
 *
 * ContractUnitNextServices is the one structured field. The page rows carry an array, empty when the unit
 * has none. The old path gave '' for none and { ContractUnitNextService: ... } otherwise, where the parser gave a
 * bare object for ONE service and an array for several (PORTAL-63). Consumers test for '' and read
 * .ContractUnitNextService, so that is rebuilt exactly, bare object for one.
 */
/**
 * asOldPathValue, plus one case it does not cover: digits with a trailing full stop ("0004864."), which the
 * old path's parser also turned into a number (4864). Found comparing Goodman on hegportal-dev, 13 Oct 2026.
 * Kept here rather than in the shared function so planned maintenance is untouched.
 */
function asOldAssetValue(value: any): any {
  if (typeof value === 'string' && /^\s*\d+\.\s*$/.test(value) && Number.isSafeInteger(Number(value.trim().slice(0, -1)))) {
    return Number(value.trim().slice(0, -1));
  }

  return asOldPathValue(value);
}

export function normaliseAssetRow(row: Record<string, any>): Record<string, any> {
  const out: Record<string, any> = {};

  Object.keys(row).forEach((key) => {
    // CompanyCode is on every page row and was never on the old path's rows.
    if (key === 'ContractUnitNextServices' || key === 'CompanyCode') {
      return;
    }

    out[key] = asOldAssetValue(row[key]);
  });

  const services = Array.isArray(row.ContractUnitNextServices) ? row.ContractUnitNextServices : [];

  out.ContractUnitNextServices = services.length === 0
    ? ''
    : { ContractUnitNextService: services.length === 1 ? normaliseRow(services[0]) : services.map((service: Record<string, any>) => normaliseRow(service)) };

  return out;
}

function normaliseRow(row: Record<string, any>): Record<string, any> {
  const out: Record<string, any> = {};

  Object.keys(row).forEach((key) => {
    out[key] = asOldAssetValue(row[key]);
  });

  return out;
}
